// extracted by mini-css-extract-plugin
export var container = "TopBar-module--container--6B0Ez";
export var reviewComponent = "TopBar-module--reviewComponent--i8wKF";
export var text = "TopBar-module--text--a2Rcj";
export var topBar = "TopBar-module--topBar--opdEF";